import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useGetPhysiciansQuery } from "app/store/transmission/api/transmissionTableApi";
import React from "react";

const PhysicianFilter = ({ value, onChange }) => {
  const { data: physicianData } = useGetPhysiciansQuery({
    isPhysicianModal: true,
  });

  return (
    <FormControl
      fullWidth
      variant="outlined"
      style={{ width: "100%" }}
      margin="none"
    >
      <InputLabel id="physician-label">Physician</InputLabel>
      <Select
        multiple
        style={{ textAlign: "left" }}
        labelId="physician-label"
        id="physician"
        name="physicians"
        variant="outlined"
        value={value ?? []}
        input={<OutlinedInput id="physician-label" label="Physician" />}
        onChange={(event) => onChange(event)}
        renderValue={(selected) => {
          const keys =
            physicianData &&
            physicianData?.map((key) => {
              return key.userId;
            });
          const item = selected.map((physician) => {
            const index = keys && keys.indexOf(physician);
            if (index !== -1) {
              return physicianData && physicianData?.[index]?.name;
            } else {
              return null;
            }
          });
          return item.join(", ");
        }}
      >
        {physicianData &&
          physicianData?.length > 0 &&
          physicianData?.map((physician, index) => {
            return (
              <MenuItem key={index} value={physician?.userId}>
                <Checkbox checked={value?.indexOf(physician?.userId) > -1} />
                <ListItemText primary={physician.name} />
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
  );
};

export default PhysicianFilter;
